export default __webpack_public_path__ + "static/media/welcome-lx-bg.d5befb46.png";